import { DateValue } from '@internationalized/date';
import { toISODateString } from '@rematter/common/dateTime';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const loadMarkAsReceivedAtom = createMutationAtomFactory(
  'customerPortal.loadMarkAsReceived',
  (params: { loadId: string; receivedDate: DateValue }) => ({
    tradeLoadReceive: {
      __args: {
        id: params.loadId,
        receivedDate: toISODateString(params.receivedDate),
      },
      id: true,
    },
  }),
  {
    skipQueue: true,
  },
);
